import React from 'react'

const Productsbox = () => {
  return (
    <div>Productsbox</div>
  )
}

export default Productsbox